// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XuQvM","logoImg":"styles_logoImg__H2Q4V","title":"styles_title__-QtEs","content":"styles_content__vPzXL","btn":"styles_btn__EQusq"};